import call from "../../service/http";
import CheckListConstants from "./CheckListConstants";
// import router from "../../router/index";

export default {
  namespaced: true,
  state: {
    checklist: [],
    loadingChecklist: false,
    categoryDisclaimer: [],
    alert: {
      status: "",
      message: "",
    },
  },
  mutations: {
    SET_LOADING_CHECKLIST: (state, payload) => {
      state.loadingChecklist = payload;
    },
    SET_CHECKLIST: (state, payload) => {
      // const currentRoute = router?.currentRoute;
      // if (currentRoute?.name === "firm-card" && currentRoute?.params?.firmCode) {

      // } else {
        state.checklist = payload;
      // }
    },
    SET_ALERT: (state, payload) => {
      state.alert = payload || {
        status: "",
        message: "",
      };
    },
    SET_CATEGORY_DISCLAIMER: (state, payload) => {
      state.categoryDisclaimer = payload;
    },
  },
  getters: {
    checklist: (state) => state.checklist,
    loadingChecklist: (state) => state.loadingChecklist,
    categoryDisclaimer: (state) => state.categoryDisclaimer,
    alert: (state) => state.alert,
  },
  actions: {
    getChecklist: ({ commit }, payload) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING_CHECKLIST", true);
      commit("SET_LOADING", true, { root: true });
      call("get", CheckListConstants.checklist(payload))
        .then((res) => {
          commit("SET_CHECKLIST", res.data.data);
          commit("SET_LOADING_CHECKLIST", false);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING_CHECKLIST", false);
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
    getCategoryDisclaimer: ({ commit }, payload) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("get", CheckListConstants.categoryDisclaimer(payload))
        .then((res) => {
          commit("SET_CATEGORY_DISCLAIMER", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
